import { render, staticRenderFns } from "./FileSplit.vue?vue&type=template&id=c1dcfe68&scoped=true"
import script from "./FileSplit.vue?vue&type=script&lang=js"
export * from "./FileSplit.vue?vue&type=script&lang=js"
import style0 from "./FileSplit.vue?vue&type=style&index=0&id=c1dcfe68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dcfe68",
  null
  
)

export default component.exports